import { render } from "./HomePage.vue?vue&type=template&id=606a3ce5&scoped=true"
const script = {}

import "./HomePage.vue?vue&type=style&index=0&id=606a3ce5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-606a3ce5"]])

export default __exports__